import { gql } from "apollo-boost";
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

/*
 *  extend type Query {
 *    getClassSection (
 *      id: ID!
 *    ): ClassSection
 *  }
 */
export const GET_CLASSSECTION = gql`
  query getClassSection($id: ID!) {
    getClassSection(
      id: $id
    ) {
      id
      courseOutline {
        id
        courseOutlineUnits{
          id seq
        }
      }
      courseOutlineRegistration {
        id periodCode
        courseOutline {
          id instruction picturePath
          courseOutlineUnits {
            id seq nameLocal nameEng descriptionLocal descriptionEng
            preTestExpectScore postTestExpectScore unitAgenda unitObjective unitReference
            countLearnPercent
            mustLearnPrevious previousPercentRequireBeforeLearn
          }
        }
        subject {
          id code nameLocal description creditCalGrade creditDesc
        }
        teacher {
          ...TeacherNameFields
          telephone
          email
          availableTime
          socialMedia
          picturePath
        }
        academicPeriod{
          id
        }
      }
      sectionNo
      descriptionLocal
      descriptionEng
      studentQty
      vdoSet {
        id totalVdoLength
        vdoSetUnits {
          id totalVdoLength
          courseOutlineUnit {
            id countLearnPercent
            mustLearnPrevious previousPercentRequireBeforeLearn
          }
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
      vdoSetCode
      startClassDate
      learnSpanNo
      examSpanNo
      classMaterials {
        id
      }
      classAssignments {
        id
      }
      classRoom{
        id capacity
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

/*
 *  extend type Query {
 *    getClassSections
 *      : [ClassSection]
 *  }
 */
export const GET_CLASSSECTIONS = gql`
  query getClassSections {
    getClassSections {
      id
      courseOutline {
        id
      }
      courseOutlineRegistration {
        id
      }
      sectionNo
      descriptionLocal
      descriptionEng
      studentQty
      vdoSet {
        id
      }
      vdoSetCode
      startClassDate
      learnSpanNo
      examSpanNo
      classMaterials {
        id
      }
      classAssignments {
        id
      }
    }
  }
`;

/*
 *  extend type Query {
 *    getClassSectionsByFilter(
 *      classSectionFilterInput: ClassSectionFilterInput
 *    ) : [ClassSection]
 *  }
 */
export const GET_CLASSSECTIONS_BY_FILTER = gql`
  query getClassSectionsByFilter(
    $classSectionFilterInput: ClassSectionFilterInput
  ) {
    getClassSectionsByFilter(
      classSectionFilterInput: $classSectionFilterInput
    )
    {
      id
      courseOutline {
        id
      }
      courseOutlineRegistration {
        id
      }
      sectionNo
      descriptionLocal
      descriptionEng
      studentRegisterQty
      studentQty
      vdoSet {
        id code totalVdoLength
        vdoSetUnits {
          id
          vdoSetTopics{
            id vdoStreamPath
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
      vdoSetCode
      startClassDate
      learnSpanNo
      examSpanNo
      classMaterials {
        id
      }
      classAssignments {
        id
      }
      classRoom {
        id nameLocal nameEng studentRegisterQty capacity startDate endDate
      }
    }
  }
`;

export const GET_CLASSSECTIONS_BY_STUDENT_NOT_REGISTER = gql`
  query getClassSectionsByStudentNotRegister(
    $studentId: ID!,
    $academicPeriodId: ID!,
    $studentEnrollId: ID
  ) {
    getClassSectionsByStudentNotRegister(
      studentId: $studentId,
      academicPeriodId: $academicPeriodId,
      studentEnrollId: $studentEnrollId
    )
    {
      id sectionNo descriptionLocal descriptionEng studentRegisterQty
      studentQty learnSpanNo examSpanNo
      courseOutlineRegistration{
        id
        periodCode
        subject {
          id code nameLocal nameEng creditCalGrade
        }
        teacher {
          ...TeacherNameFields
          picturePath
        }
        classSections {
          id sectionNo descriptionLocal descriptionEng studentRegisterQty
          studentQty learnSpanNo examSpanNo
        }
      }

    }
  }

  ${TEACHER_NAME_FIELDS}
`;

/*
 *  extend type Mutation {
 *    addClassSection(
 *      courseOutlineId: ID!,
 *      courseOutlineRegistrationId: ID!,
 *      vdoSetId: ID,
 *      classSectionInput: ClassSectionInput!
 *    ) : ClassSection!
 *  }
 */
export const ADD_CLASSSECTION = gql`
  mutation addClassSection(
    $courseOutlineId: ID!,
    $courseOutlineRegistrationId: ID!,
    $vdoSetId: ID,
    $classRoomId: ID,
    $classRoomOwnedId: ID,
    $classRoomCreateInput: ClassRoomCreateInput
    $classSectionInput: ClassSectionInput!
  ) {
    addClassSection (
      courseOutlineId: $courseOutlineId,
      courseOutlineRegistrationId: $courseOutlineRegistrationId,
      vdoSetId: $vdoSetId,
      classRoomId: $classRoomId,
      classRoomOwnedId: $classRoomOwnedId,
      classRoomCreateInput: $classRoomCreateInput
      classSectionInput: $classSectionInput
    )
    {
      id
      courseOutline {
        id
      }
      courseOutlineRegistration {
        id
      }
      sectionNo
      descriptionLocal
      descriptionEng
      studentQty
      vdoSet {
        id code totalVdoLength
        vdoSetUnits {
          id
          vdoSetTopics{
            id vdoStreamPath
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
      vdoSetCode
      startClassDate
      learnSpanNo
      examSpanNo
      classMaterials {
        id
      }
      classAssignments {
        id
      }
      classRoom {
        id nameLocal nameEng studentRegisterQty capacity startDate endDate
      }
    }
  }
`;

/*
 *  extend type Mutation {
 *    updateClassSection(
 *      id: ID!,
 *      vdoSetId: ID,
 *      classSectionInput: ClassSectionInput!
 *    ) : ClassSection!
 *  }
 */
export const UPDATE_CLASSSECTION = gql`
  mutation updateClassSection(
    $id: ID!,
    $vdoSetId: ID,
    $courseOutlineRegistrationId: ID!,
    $classRoomId: ID,
    $classRoomOwnedId: ID,
    $classRoomCreateInput: ClassRoomCreateInput
    $classSectionInput: ClassSectionInput!
  ) {
    updateClassSection (
      id: $id,
      vdoSetId: $vdoSetId,
      courseOutlineRegistrationId: $courseOutlineRegistrationId,
      classRoomId: $classRoomId,
      classRoomOwnedId: $classRoomOwnedId,
      classRoomCreateInput: $classRoomCreateInput
      classSectionInput: $classSectionInput
    )
    {
      id
      courseOutline {
        id
      }
      courseOutlineRegistration {
        id
      }
      sectionNo
      descriptionLocal
      descriptionEng
      studentQty
      vdoSet {
        id code totalVdoLength
        vdoSetUnits {
          id
          vdoSetTopics{
            id vdoStreamPath
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
      vdoSetCode
      startClassDate
      learnSpanNo
      examSpanNo
      classMaterials {
        id
      }
      classAssignments {
        id
      }
      classRoom {
        id nameLocal nameEng studentRegisterQty capacity startDate endDate
      }
    }
  }
`;

/*
 *  extend type Mutation {
 *    deleteClassSection(
 *      id: ID!
 *    ) : ClassSection!
 *  }
 */
export const DELETE_CLASSSECTION = gql`
  mutation deleteClassSection(
    $id: ID!
  ) {
    deleteClassSection (
      id: $id
    ) {
      id
      courseOutline {
        id
      }
      courseOutlineRegistration {
        id
      }
      sectionNo
      descriptionLocal
      descriptionEng
      studentQty
      vdoSet {
        id code totalVdoLength
        vdoSetUnits {
          id
          vdoSetTopics{
            id vdoStreamPath
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
      vdoSetCode
      startClassDate
      learnSpanNo
      examSpanNo
      classMaterials {
        id
      }
      classAssignments {
        id
      }
      classRoom {
        id nameLocal nameEng studentRegisterQty capacity startDate endDate
      }
    }
  }
`;


/* TYPES
input ClassSectionFilterInput {
  courseOutlineId: ID
  courseOutlineRegistrationId: ID
  sectionNo: Int
  vdoSetId: ID
  vdoSetCode: String
  startClassDate: String
  learnSpanNo: Int
  examSpanNo: Int
}

input ClassSectionInput {
  sectionNo: Int
  descriptionLocal: String
  descriptionEng: String
  studentQty: Int
  vdoSetCode: String
  startClassDate: String
  learnSpanNo: Int
  examSpanNo: Int
}

type ClassSection {
  id: ID!
  courseOutline: CourseOutline!
  courseOutlineRegistration: CourseOutlineRegistration!
  sectionNo: Int
  descriptionLocal: String
  descriptionEng: String
  studentQty: Int
  vdoSet: VdoSet
  vdoSetCode: String
  startClassDate: String
  learnSpanNo: Int
  examSpanNo: Int
  classMaterials: [ClassMaterial]
  classAssignments: [ClassAssignment]
  isDisabled: Boolean!
  createdAt: String!
  updatedAt: String!
  createdBy: User
  updatedBy: User
}
*/
